module.exports = __webpack_public_path__ + "img/login-img.57a57310.svg";